"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Check from foundation/Check
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Checkmark = createSVGIcon(
  <path
    d="m6.087 10.465-2.07-2.207a.57.57 0 0 0-.842 0 .663.663 0 0 0 0 .897l2.494 2.659a.57.57 0 0 0 .842 0l6.314-6.73a.663.663 0 0 0 0-.898.57.57 0 0 0-.841 0z"
    fill="currentColor"
  />,
  "Checkmark",
  { viewBox: "0 0 16 16", titleAccess: "Checkmark", strokeWidth: 1.5 }
);
